<template>
  <v-layout align-center column class="home">
    <img alt="Vue logo" src="/img/icons/heap-32x32.png">
    <v-list>
      <template v-for="(val, key) in getEnv()">
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-title v-html="key"></v-list-tile-title>
            <v-list-tile-sub-title v-html="val"></v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </template>
    </v-list>
  </v-layout>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'home',
  components: {
  },
  mounted () {
  },
  methods: {
    getEnv() {
      console.log(process.env)
      return process.env
    }
  }
}
</script>
